// extracted by mini-css-extract-plugin
export default {"acceptForm":"AcceptForm_acceptForm__PYDK2","acceptForm__content":"AcceptForm_acceptForm__content__BAHrv"};